import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import banksAPI from '../../utils/api/banks';

export const fetchBanks = createAsyncThunk(
  'banks/fetchBanks',
  async (_, { rejectWithValue }) => {
    try {
      const response = await banksAPI.getAll();
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const createBank = createAsyncThunk(
  'banks/createBank',
  async (bankData, { rejectWithValue }) => {
    try {
      const response = await banksAPI.create(bankData);
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateBank = createAsyncThunk(
  'banks/updateBank',
  async ({ id, bankData }, { rejectWithValue }) => {
    try {
      const response = await banksAPI.update(id, bankData);
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteBank = createAsyncThunk(
  'banks/deleteBank',
  async (id, { rejectWithValue }) => {
    try {
      await banksAPI.delete(id);
      return id;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const initialState = {
  banks: [],
  loading: false,
  error: null
};

const banksSlice = createSlice({
  name: 'banks',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    clearBanksState: (state) => {
      state.banks = [];
      state.loading = false;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      // Fetch Banks
      .addCase(fetchBanks.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.banks = [];
      })
      .addCase(fetchBanks.fulfilled, (state, action) => {
        state.loading = false;
        state.banks = action.payload.data;
      })
      .addCase(fetchBanks.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Create Bank
      .addCase(createBank.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createBank.fulfilled, (state, action) => {
        state.loading = false;
        state.banks.push(action.payload);
      })
      .addCase(createBank.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Update Bank
      .addCase(updateBank.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateBank.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.banks.findIndex(bank => bank.id === action.payload.id);
        if (index !== -1) {
          state.banks[index] = action.payload;
        }
      })
      .addCase(updateBank.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Delete Bank
      .addCase(deleteBank.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteBank.fulfilled, (state, action) => {
        state.loading = false;
        state.banks = state.banks.filter(bank => bank.id !== action.payload);
      })
      .addCase(deleteBank.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { clearError, setLoading, setError, clearBanksState } = banksSlice.actions;
export default banksSlice.reducer; 